module.exports = __webpack_public_path__ + "static/media/geotolk-blue.ad9fcd23.svg";